import { gql } from '@apollo/client'
import { Button } from '@farol-ds/react'
import classNames from 'classnames'

import { useChooseFrequencyLaterEvents } from '../../../../hooks/use-choose-frequency-later-events'
import { CheckoutButton } from '../../../checkout-button'
import { OneClickButton } from '../../../one-click-button'
import {
  ChooseFrequencyLaterPaymentFooter_OfferLockCardFragment,
  ChooseFrequencyLaterPaymentFooter_ViewerFragment,
} from './__generated__/choose-frequency-later-payment-footer.graphql'
import styles from './choose-frequency-later-payment-footer.module.scss'

interface ChooseFrequencyLaterPaymentFooterProps {
  offerLockCard: ChooseFrequencyLaterPaymentFooter_OfferLockCardFragment
  viewer: ChooseFrequencyLaterPaymentFooter_ViewerFragment
  isPaywall: boolean
  onBackBtnClick: () => void
}

export function ChooseFrequencyLaterPaymentFooter({
  offerLockCard,
  viewer,
  isPaywall,
  onBackBtnClick,
}: ChooseFrequencyLaterPaymentFooterProps) {
  const { metricsRef, sendReturnToOffersEvent } = useChooseFrequencyLaterEvents()

  const hasViewer = !!viewer
  const hasCreditCard = !!offerLockCard?.creditCard?.ccToken
  const shouldUseOneClick = hasCreditCard && hasViewer

  const buttonLabel = offerLockCard?.buttons?.[1]?.label || 'Confirmar assinatura'
  const buttonKind = offerLockCard?.buttons?.[1]?.kind || 'primary'

  const handleBackBtnClick = () => {
    offerLockCard && sendReturnToOffersEvent(offerLockCard)
    onBackBtnClick()
  }

  const footerClasses = classNames(styles.footer, { [styles.footerPaywall]: isPaywall })

  return (
    <div className={footerClasses}>
      <Button ref={metricsRef} kind="tertiary" onClick={handleBackBtnClick}>
        Voltar
      </Button>

      {shouldUseOneClick ? (
        <OneClickButton
          offerLockCard={offerLockCard}
          viewer={viewer}
          kind={buttonKind}
          customLabel={buttonLabel}
        />
      ) : (
        <CheckoutButton
          forceCheckout
          offerLockCard={offerLockCard}
          kind={buttonKind}
          customLabel={buttonLabel}
        />
      )}
    </div>
  )
}

ChooseFrequencyLaterPaymentFooter.fragments = {
  offerLockCard: gql`
    fragment ChooseFrequencyLaterPaymentFooter_offerLockCard on OfferLockCard {
      buttons {
        label
        kind
      }
      ...UseChooseFrequencyLaterEvents_offerLockCard
      ...OneClickButton_offerLockCard
      ...CheckoutButton_offerLockCard
    }
    ${useChooseFrequencyLaterEvents.fragments.offerLockCard}
    ${OneClickButton.fragments.offerLockCard}
    ${CheckoutButton.fragments.offerLockCard}
  `,
  viewer: gql`
    fragment ChooseFrequencyLaterPaymentFooter_viewer on Profile {
      ...OneClickButton_viewer
    }
    ${OneClickButton.fragments.viewer}
  `,
}
